import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

const alreadyDeletedResponse = (): AxiosResponse =>
  ({
    data: {},
    status: 200,
    statusText: "OK",
    headers: {},
    config: { headers: {} } as AxiosRequestConfig,
  }) as AxiosResponse;

/**
 * Deletes a Tixologi event. A 404 resolves like a success: the host deletes the
 * Tixologi event BEFORE the Punchup row, so a show whose Punchup delete failed
 * on an earlier attempt points at an event that is already gone — retrying must
 * be able to finish the job rather than fail on the missing event.
 */
export async function deleteTixologiEvent(
  eventId: string | null | undefined,
  token: string | undefined
): Promise<AxiosResponse> {
  if (!eventId) {
    return alreadyDeletedResponse();
  }

  try {
    return await axios.delete(
      process.env.NEXT_PUBLIC_TIXOLOGI_API_URL + `/events/${eventId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 404) {
      return alreadyDeletedResponse();
    }
    throw error;
  }
}
